import React from "react";
import { Plus, Minus, RefreshCcw, Accessibility } from "lucide-react";
import { useFontSize } from "../../hooks/useFontSize";

export default function AccessibilityWidget({ className = "" }) {
  const { fontSize, increaseFont, decreaseFont, resetFont } = useFontSize(14);

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "6px",
        padding: "4px 8px",
        width: "100%",
        flexShrink: 0,
        minWidth: "fit-content",
        overflow: "visible",
      }}
    >
      {/* <Accessibility
        size={14}
        className="text-gray-600"
        title="Text size controls"
        style={{ flexShrink: 0 }}
      /> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          flexShrink: 0,
        }}
      >
        <button
          onClick={decreaseFont}
          style={{
            padding: "4px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="hover:bg-gray-100"
          title="Decrease"
        >
          <Minus size={16} className="text-gray-700" />
        </button>
        <button
          onClick={resetFont}
          style={{
            padding: "4px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="hover:bg-gray-100"
          title="Reset"
        >
          <RefreshCcw size={16} className="text-gray-700" />
        </button>
        <button
          onClick={increaseFont}
          style={{
            padding: "4px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="hover:bg-gray-100"
          title="Increase"
        >
          <Plus size={16} className="text-gray-700" />
        </button>
      </div>
    </div>
  );
}